import React from "react";
import BadgeOrigineFranceTravail, {
  estOrigineFranceTravail,
} from "../../BadgeOrigineFranceTravail";
import BadgeDemandeSuspensionRemobilisation, {
  aDemandeSuspensionRemobilisation,
  BanniereDemandeSuspensionRemobilisation,
} from "../../EncartDemandeSuspensionRemobilisation";
import { DETECTION_TYPES } from "../../../RecipientDetail/sanctionConstants";
import { getDetectionLabel, getDetectionStyle } from "./DecisionModalHelpers";

const DecisionModalBanner = ({ inscription, sanctionStyle, isOver62 }) => {
  return (
    <>
      {/* Allocataire banner */}
      <div
        className="d-flex align-items-center justify-content-between px-4 py-3"
        style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}
      >
        <div className="d-flex align-items-center" style={{ gap: 12 }}>
          <div
            className="d-flex align-items-center justify-content-center font-weight-bold"
            style={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #e2e8f0, #cbd5e1)",
              color: "#475569",
              fontSize: 15,
            }}
          >
            {(inscription.userRecipient?.fullname || "?")[0]}
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>
              {inscription.userRecipient?.fullname || "—"}
            </div>
            <div
              className="d-flex flex-wrap align-items-center"
              style={{ gap: 6, fontSize: 12, color: "#64748b" }}
            >
              <span>NIR: {inscription.userRecipient?.nir || "—"}</span>
              <span style={{ color: "#cbd5e1" }}>|</span>
              <span>{inscription.userRecipient?.age || "—"}</span>
              <span style={{ color: "#cbd5e1" }}>|</span>
              <span>
                {inscription.userRecipient?.sddStatus ? "SDD" : "NSDD"}
              </span>
              {inscription.userRecipient?.maritalStatusLabel && (
                <>
                  <span style={{ color: "#cbd5e1" }}>|</span>
                  <span>{inscription.userRecipient.maritalStatusLabel}</span>
                </>
              )}
              {inscription.userRecipient?.rsaTypeLabel && (
                <>
                  <span style={{ color: "#cbd5e1" }}>|</span>
                  <span>{inscription.userRecipient.rsaTypeLabel}</span>
                </>
              )}
              {inscription.userRecipient?.professionalSituation && (
                <>
                  <span style={{ color: "#cbd5e1" }}>|</span>
                  <span>{inscription.userRecipient.professionalSituation}</span>
                </>
              )}
            </div>
            {(inscription.userRecipient?.city ||
              inscription.userRecipient?.orientationPartner ||
              inscription.userRecipient?.nbChildrenOrDependant > 0) && (
              <div
                className="d-flex flex-wrap align-items-center mt-1"
                style={{ gap: 6, fontSize: 11, color: "#94a3b8" }}
              >
                {inscription.userRecipient?.city && (
                  <span>
                    <i
                      className="fa fa-map-marker mr-1"
                      style={{ fontSize: 10 }}
                    />
                    {inscription.userRecipient.postalCode}{" "}
                    {inscription.userRecipient.city}
                  </span>
                )}
                {inscription.userRecipient?.orientationPartner && (
                  <>
                    <span style={{ color: "#e2e8f0" }}>|</span>
                    <span>
                      <i
                        className="fa fa-building mr-1"
                        style={{ fontSize: 10 }}
                      />
                      {inscription.userRecipient.orientationPartner}
                    </span>
                  </>
                )}
                {inscription.userRecipient?.nbChildrenOrDependant > 0 && (
                  <>
                    <span style={{ color: "#e2e8f0" }}>|</span>
                    <span>
                      <i
                        className="fa fa-child mr-1"
                        style={{ fontSize: 10 }}
                      />
                      {inscription.userRecipient.nbChildrenOrDependant}{" "}
                      enfant(s)/pers. à charge
                    </span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex" style={{ gap: 6 }}>
          <span
            className="d-inline-flex align-items-center px-2 py-1 rounded"
            style={{
              background: sanctionStyle.bg,
              color: sanctionStyle.color,
              fontSize: 12,
              fontWeight: 700,
              gap: 5,
            }}
          >
            <i
              className={`fa ${sanctionStyle.icon}`}
              style={{ fontSize: 11 }}
            />
            {sanctionStyle.label}
          </span>
          {isOver62 && (
            <span
              className="d-inline-flex align-items-center px-2 py-1 rounded"
              style={{
                background: "#fef3c7",
                color: "#92400e",
                fontSize: 12,
                fontWeight: 700,
                gap: 5,
              }}
            >
              <i
                className="fa fa-exclamation-triangle"
                style={{ fontSize: 11 }}
              />
              +62 ans
            </span>
          )}
          {inscription.pregnancy && (
            <span
              className="d-inline-flex align-items-center px-2 py-1 rounded"
              style={{
                background: "#fce7f3",
                color: "#9d174d",
                fontSize: 12,
                fontWeight: 700,
                gap: 5,
              }}
            >
              <i className="fa fa-baby" style={{ fontSize: 11 }} />
              Grossesse
            </span>
          )}
          {estOrigineFranceTravail(inscription) && (
            <BadgeOrigineFranceTravail fontSize={12} />
          )}
          {aDemandeSuspensionRemobilisation(inscription) && (
            <BadgeDemandeSuspensionRemobilisation
              demandeSuspensionRemobilisation={inscription.demandeSuspensionRemobilisation}
              allocataireNom={inscription.userRecipient?.fullname}
              fontSize={12}
            />
          )}
        </div>
      </div>

      {/* Alerte > 62 ans */}
      {isOver62 && (
        <div
          className="d-flex align-items-center px-4 py-2"
          style={{
            background: "linear-gradient(135deg, #fef3c7, #fde68a)",
            gap: 10,
          }}
        >
          <i
            className="fa fa-exclamation-triangle"
            style={{ fontSize: 16, color: "#92400e" }}
          />
          <span style={{ fontSize: 13, color: "#92400e", fontWeight: 700 }}>
            ATTENTION : Allocataire de plus de 62 ans — Ne doit pas être
            sanctionné
          </span>
        </div>
      )}

      {/* Demande de levée : à voir en entier au moment de statuer */}
      {aDemandeSuspensionRemobilisation(inscription) && (
        <BanniereDemandeSuspensionRemobilisation
          demandeSuspensionRemobilisation={inscription.demandeSuspensionRemobilisation}
        />
      )}

      {/* Détection type banner */}
      {inscription.detectionType && (
        <div
          className="d-flex align-items-center px-4 py-2"
          style={{
            background: getDetectionStyle(inscription.detectionType).bg,
            borderBottom:
              inscription.detectionType !== DETECTION_TYPES.PREMIER
                ? `3px solid ${getDetectionStyle(inscription.detectionType).border}`
                : `1px solid ${getDetectionStyle(inscription.detectionType).border}`,
            gap: 10,
          }}
        >
          <i
            className={`fa ${inscription.detectionType === DETECTION_TYPES.PREMIER ? "fa-info-circle" : "fa-bolt"}`}
            style={{
              fontSize: 16,
              color: getDetectionStyle(inscription.detectionType).color,
            }}
          />
          <div>
            <span
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: getDetectionStyle(inscription.detectionType).color,
              }}
            >
              {getDetectionLabel(inscription.detectionType)}
            </span>
            {inscription.detectionType !== DETECTION_TYPES.PREMIER && (
              <span
                style={{
                  fontSize: 12,
                  color: getDetectionStyle(inscription.detectionType).color,
                  marginLeft: 8,
                }}
              >
                — Le barème a été adapté automatiquement
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DecisionModalBanner;
